import ajax from "../../lib/appfuse-react/core/ajax";
import {setAuthenticated, setIsIdleAccount, setToken, setVerifyToken} from "../../reducer/iam/authReducer";
import store from "../../store";

const authService = {
    login: async (authorization) => {
        let response;
        try {
            response = await ajax.get('login', {}, {
                authorization: authorization
            });
            if(response.data) {
                const {status, token} = response.data;
                store.dispatch(setIsIdleAccount(status === 'idle'));
                if (status === 'idle') {
                    store.dispatch(setVerifyToken(token));
                }
            }
            if(response.authorization) {
                store.dispatch(setToken(response.authorization));
                store.dispatch(setAuthenticated(true));
            }
        } catch(e) {
            store.dispatch(setToken(null));
            store.dispatch(setAuthenticated(false));
            throw e;
        }

        return response.data;
    },
    logout: () => {
        store.dispatch(setToken(null));
        store.dispatch(setAuthenticated(false));
    },
    fetchApplets: async () => {
        const response = await ajax.get('applets/web');
        return response.data;
    },
    fetchUserInfo: async () => {
        const response = await ajax.get('accounts/userInfoFromWeb');
        return response.data;
    },
    forgotPassword: async (username) => {
        await ajax.get(`accounts/forgetPassword/${username}`);
    },
    changePassword: async (data) => {
        await ajax.post('accounts/changePassword', data);
    },
    verify: async (token, pin) => {
        const authorization = `Bearer ${token}`;
        const response = await ajax.get('login', {}, {
            authorization: authorization,
            headers: {pin}
        });
        if(response.authorization) {
            store.dispatch(setToken(response.authorization));
            store.dispatch(setAuthenticated(true));
        }
    },
    verifyIdle: async (token, pin) => {
        const authorization = `Bearer ${token}`;
        const response = await ajax.get('login',{} ,{
            authorization: authorization,
            headers: {pin}
        });
        if(response.authorization) {
            store.dispatch(setIsIdleAccount(false));
            store.dispatch(setToken(response.authorization));
            store.dispatch(setAuthenticated(true));
        }
    }
}

export default authService;
